<template>
  <div class="leading-relaxed space-y-10">
    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">Введение</h2>
      <p>
        Настоящая Политика конфиденциальности объясняет, как MEDIUM.am («мы»,
        «наш» или «нас») собирает, использует и защищает информацию при
        использовании платформы MEDIUM.am («Сервис»).
      </p>
      <p class="mt-2">
        MEDIUM.am — это цифровое пространство, где встречаются художники и
        ценители искусства. Данная политика описывает наши обязательства по
        соблюдению вашей конфиденциальности при взаимодействии с нашим
        сообществом и услугами.
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        Данные аккаунта и аутентификации
      </h2>
      <p>
        Для доступа к определенным функциям и управления своим профилем
        пользователи должны создать аккаунт или пройти аутентификацию на
        платформе. Пользователи могут авторизоваться с помощью регистрации по
        электронной почте или через Google Sign-In.
      </p>
      <p class="mt-4 font-medium">
        Независимо от того, входит ли пользователь с помощью адреса электронной
        почты и пароля, через Google или Facebook, мы собираем ту же базовую
        информацию, необходимую для создания и управления учетной записью:
      </p>
      <ul class="list-disc list-inside mt-2 space-y-1 ml-4">
        <li>Имя</li>
        <li>Фамилия</li>
        <li>Адрес электронной почты</li>
        <li>Аватар профиля (если предоставлен)</li>
        <li>Номер телефона (если предоставлен)</li>
        <li>Биография / Bio (если предоставлено)</li>
        <li>Дата рождения (если предоставлена)</li>
      </ul>
      <p class="mt-4 italic">
        Доступ к дополнительным пользовательским данным, помимо перечисленных
        выше, не осуществляется. Мы не имеем доступа к вашим контактам в Google
        или Facebook, календарям, спискам друзей, файлам или любым другим
        сторонним сервисам. Вход через Google, Facebook или электронную почту
        предоставляет ту же ограниченную информацию, необходимую для вашего
        аккаунта.
      </p>

      <p class="mt-2">
        Эта информация используется исключительно для идентификации аккаунта,
        аутентификации, поддержки клиентов и контроля доступа к сервису.
      </p>
      <p class="mt-2">
        Аутентификация обрабатывается с использованием защищенных файлов cookie
        (HTTP-only) для управления сессиями. Мы не используем файлы cookie для
        рекламы или отслеживания.
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        Связь художников и любителей искусства
      </h2>
      <p>
        MEDIUM.am выступает в качестве связующего звена между создателями и
        энтузиастами. Мы способствуем этим связям, отображая профессиональную
        информацию, предоставленную художниками сообществу.
      </p>
      <p class="mt-2">
        <strong>Платежи:</strong> В настоящее время MEDIUM.am не обрабатывает
        платежи и не выступает в качестве платежного посредника. Любые
        транзакции или соглашения, заключенные между пользователями, проводятся
        вне платформы и не подпадают под действие настоящей Политики
        конфиденциальности.
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        Файлы Cookie и локальное хранилище
      </h2>
      <p>
        Платформа MEDIUM.am использует файлы cookie строго для аутентификации и
        управления сессиями. Минимальное локальное хранилище (local storage)
        может использоваться для сохранения нечувствительных пользовательских
        настроек, таких как параметры интерфейса или выбор языка.
      </p>
      <p class="mt-2">
        Мы не используем файлы cookie для отслеживания, рекламные файлы cookie
        или сторонние аналитические файлы cookie.
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        Импорт из Instagram и обработка данных
      </h2>

      <p>
        MEDIUM.am позволяет зарегистрированным пользователям импортировать
        изображения из собственных публикаций Instagram с изображениями и
        использовать их для создания черновиков произведений искусства. Для
        использования этой функции пользователи должны подключить принадлежащий
        им аккаунт Instagram и разрешить MEDIUM.am доступ к информации,
        необходимой для работы интеграции.
      </p>

      <p class="mt-2">
        <strong>Подключение аккаунта Instagram:</strong> Когда пользователь
        нажимает кнопку «Подключить Instagram», ему предлагается при
        необходимости войти в Instagram и предоставить запрашиваемый доступ
        через процедуру авторизации Meta. В настольных браузерах этот процесс
        открывается во всплывающем окне, а на мобильных устройствах пользователь
        перенаправляется в Instagram. После успешной авторизации пользователь
        возвращается в панель управления MEDIUM.am, где может проверить,
        подключён ли его аккаунт Instagram.
      </p>

      <p class="mt-2">
        <strong>Хранение данных аккаунта и токена:</strong> Для поддержания
        подключения MEDIUM.am безопасно хранит в своей базе данных имя
        пользователя подключённого аккаунта Instagram, токен доступа и связанные
        с ним данные проверки действительности и срока действия. Первоначальный
        краткосрочный токен обменивается на долгосрочный токен, действительный
        примерно 60 дней. После истечения срока действия токена подключение
        становится недействительным, и пользователю необходимо повторно
        подключить аккаунт Instagram, чтобы продолжить пользоваться этой
        функцией. Пользователь может отключить свой аккаунт Instagram в любое
        время. При отключении сохранённые в MEDIUM.am данные подключения
        Instagram безвозвратно удаляются.
      </p>

      <p class="mt-2">
        <strong>Получение и просмотр публикаций:</strong> После подключения
        аккаунта пользователь может открыть окно импорта Instagram, чтобы
        получить и просмотреть доступные публикации с изображениями. В настоящее
        время MEDIUM.am получает и отображает только публикации с изображениями;
        видео и другие неподдерживаемые типы медиа через эту функцию не
        импортируются. Если доступны дополнительные публикации, пользователь
        может загружать их партиями до 25 публикаций за один раз.
      </p>

      <p class="mt-2">
        <strong>Временные данные публикаций:</strong> Информация о публикациях,
        полученная для просмотра в окне импорта, временно хранится в памяти
        браузера приложения. Данные просмотра не сохраняются в нашей базе данных
        и не собираются в фоновом режиме. После закрытия окна эти временные
        данные очищаются. Получение и просмотр публикаций сами по себе не
        создают записи произведений искусства и не сохраняют просмотренные
        публикации в MEDIUM.am.
      </p>

      <p class="mt-2">
        <strong>Данные, сохраняемые при импорте публикации:</strong> Когда
        пользователь явно импортирует публикацию, MEDIUM.am создаёт в своей базе
        данных черновик произведения искусства. Черновик включает изображение
        выбранной публикации, её подпись, ссылку на исходную публикацию
        Instagram и ID публикации Instagram. Этот ID используется для
        распознавания ранее импортированных публикаций и предотвращения
        повторного импорта одной и той же публикации. Запись произведения
        связывается с аккаунтом пользователя MEDIUM.am и сохраняется как
        черновик, пока пользователь не заполнит необходимые сведения и не
        опубликует произведение.
      </p>

      <p class="mt-2">
        <strong>Черновики и публикация:</strong> Импортированные черновики
        произведений искусства не отображаются публично в галерее MEDIUM.am,
        пока пользователь не завершит их оформление и не опубликует их. До
        публикации пользователи могут редактировать черновики. После публикации
        произведение становится общедоступным в соответствии с обычными
        настройками публикации и правилами MEDIUM.am.
      </p>

      <p class="mt-2">
        <strong>Удаление импортированных публикаций и произведений:</strong>
        Пользователи могут удалить публикацию из списка импорта Instagram, не
        обязательно удаляя связанное с ней произведение искусства. Если
        связанное произведение всё ещё является черновиком, при удалении
        публикации удаляются черновик, сохранённые файлы его изображений и
        запись об импорте Instagram. Если произведение уже опубликовано,
        удаление публикации из списка импорта удаляет только связанную запись об
        импорте Instagram; опубликованное произведение и связанный с ним контент
        остаются доступными на MEDIUM.am. Это позволяет пользователю повторно
        импортировать ту же публикацию Instagram в будущем.
      </p>

      <p class="mt-2">
        Пользователи также могут отдельно удалять свои произведения искусства,
        включая опубликованные, через платформу MEDIUM.am. При удалении
        произведения связанная с ним запись об импорте Instagram также
        удаляется, если она ещё существует. Удаление произведения не удаляет
        исходную публикацию из Instagram.
      </p>

      <p class="mt-2">
        <strong>Цели использования и передача данных:</strong> Данные аккаунта
        Instagram и импортированных публикаций используются для поддержания
        подключения, получения публикаций с изображениями по запросу
        пользователя и создания черновиков произведений на основе публикаций,
        выбранных пользователем. MEDIUM.am не продаёт эту информацию и не
        использует её для несвязанных фоновых сборов данных. Доступ к данным
        Instagram зависит от разрешений, предоставленных пользователем, и
        механизмов авторизации Meta.
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        Передача и раскрытие данных
      </h2>
      <p>
        Мы не продаем, не сдаем в аренду и не обмениваем персональные данные.
        Данные могут быть раскрыты только в случаях, предусмотренных законом,
        или для выполнения законных требований. В таких случаях раскрытие
        ограничивается минимальным объемом информации, требуемым по закону.
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">Ваши права</h2>
      <ul class="list-disc list-inside space-y-2">
        <li>
          Вы можете запросить доступ к информации вашего аккаунта в любое время.
        </li>
        <li>
          Вы можете запросить исправление или удаление вашего аккаунта и
          персональных данных.
        </li>
        <li>
          Вы можете выйти из системы в любое время, чтобы очистить файлы cookie
          аутентификации.
        </li>
        <li>
          Вы можете связаться с нами по любым вопросам, связанным с
          конфиденциальностью.
        </li>
      </ul>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">Связаться с нами</h2>
      <p>
        Если у вас есть какие-либо вопросы или сомнения относительно настоящей
        Политики конфиденциальности, вы можете связаться с нами по адресу:
      </p>
      <p class="text-primary font-bold mt-2">contact@medium.am</p>
    </section>
  </div>
</template>
